import {BootstrapBreakpoint, bootstrapBreakpointByName} from "../../../common/resolutionConstants";
import {Resolution} from "../../../common/resolution";
import {resolve} from "../../../container";

export class DialogActivation {
    private activationBreakpoint: BootstrapBreakpoint | null;
    private active: boolean;

    public constructor(
        private element: HTMLElement,
        activationBreakpointName: string = "sm",
        private resolution: Resolution = resolve(Resolution)
    ) {
        this.activationBreakpoint = bootstrapBreakpointByName(activationBreakpointName);
        this.setActive(!this.activationBreakpoint || this.resolution.downTo(this.activationBreakpoint));
        if (this.activationBreakpoint) {
            this.resolution.onBootstrapBreakpointChange(breakpoint => {
                this.setActive(breakpoint.isDownTo(this.activationBreakpoint!));
            });
        }
    }

    public ifActive(callback: () => void): void {
        if (this.active) {
            callback();
        }
    }

    private setActive(value: boolean): void {
        this.active = value;
        if (this.active) {
            this.element.style.cursor = "pointer";
        } else {
            this.element.style.cursor = "";
        }
    }
}
